import React from "react";
import { useNavigate } from "react-router-dom";
import "./publications_flip_card.css";

const defaultImage = process.env.PUBLIC_URL + "Logo_AdaLab.png";

function PublicationFlipCard({ publicacion, mediaUrl, tiposPublicacion }) {
  const navigate = useNavigate();

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };

  const handleClick = () => {
    navigate(`/publicationsID/${publicacion.id}`);
  };

  const imageUrl = publicacion.ruta_imagen || defaultImage;

  // Obtener el nombre del tipo de publicación
  const tipoPublicacion = tiposPublicacion?.find(
    tipo => tipo.id === publicacion.tipo_publicacion_id
  );

  // Formatear la fecha de publicación
  const formatearFecha = (fechaString) => {
    if (!fechaString) return null;
    const opciones = { year: "numeric", month: "long", day: "numeric" };
    const fecha = new Date(fechaString);
    return fecha.toLocaleDateString("es-ES", opciones);
  };

  return (
    <div className="flip-card-pub" onClick={handleClick}>
      <div className="flip-card-inner-pub">
        {/* Parte frontal - Imagen y título */}
        <div className="flip-card-front-pub">
          <div className="flip-card-image-container-pub">
            <img
              src={imageUrl}
              alt={publicacion.titulo}
              className="flip-card-image-pub"
            />
          </div>
          <div className="flip-card-info-pub">
            <h3 className="flip-card-title-pub">
              {publicacion.titulo}
            </h3>
            {publicacion.anio && (
              <span className="flip-card-year-pub">
                {publicacion.anio}
              </span>
            )}
            <span className="flip-card-cta-pub">
              Click para ver más →
            </span>
          </div>
        </div>

        {/* Parte trasera - Descripción */}
        <div className="flip-card-back-pub">
          <div className="flip-card-back-content-pub">
            <p className="flip-card-description-pub">
              {truncateText(publicacion.descripcion, 350)}
            </p>
            <div className="flip-card-metadata-pub">
              {publicacion.rev_eve && (
                <p className="flip-card-venue-pub">
                  📖 {truncateText(publicacion.rev_eve, 60)}
                </p>
              )}
              {publicacion.fecha_publicacion && (
                <p className="flip-card-year-back-pub">
                  📅 {formatearFecha(publicacion.fecha_publicacion)}
                </p>
              )}
              {tipoPublicacion && (
                <p className="flip-card-type-pub">
                  🏷️ {tipoPublicacion.nombre}
                </p>
              )}
            </div>
            <span className="flip-card-cta-pub">
              Click para ver más →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PublicationFlipCard;
